export enum EnumContaViagemSituacao {
    EmLancamento = 1,
    Lancado = 2,
    Encerrado = 3
}

export const ContaViagemSituacoesDicionario:Record<EnumContaViagemSituacao, string> = {
    [EnumContaViagemSituacao.EmLancamento] : "Em lançamento",
    [EnumContaViagemSituacao.Lancado] : "Lançado",
    [EnumContaViagemSituacao.Encerrado] : "Encerrado"
}

export const ContaViagemSituacoesDicionarioAcao:Record<EnumContaViagemSituacao, string> = {
    [EnumContaViagemSituacao.EmLancamento] : "Abrir",
    [EnumContaViagemSituacao.Lancado] : "Lançar",
    [EnumContaViagemSituacao.Encerrado] : "Encerrar"
}

export const ContaViagemSituacoesDicionarioProximaAcao:Record<EnumContaViagemSituacao, EnumContaViagemSituacao> = {
    [EnumContaViagemSituacao.EmLancamento] : EnumContaViagemSituacao.Lancado,
    [EnumContaViagemSituacao.Lancado] : EnumContaViagemSituacao.Encerrado,
    [EnumContaViagemSituacao.Encerrado] : EnumContaViagemSituacao.EmLancamento
}

export const ContaViagemSituacoesLista = [
    {
        value : EnumContaViagemSituacao.EmLancamento,
        label : ContaViagemSituacoesDicionario[EnumContaViagemSituacao.EmLancamento]
    },
    {
        value : EnumContaViagemSituacao.Lancado,
        label : ContaViagemSituacoesDicionario[EnumContaViagemSituacao.Lancado]
    },
    {
        value : EnumContaViagemSituacao.Encerrado,
        label : ContaViagemSituacoesDicionario[EnumContaViagemSituacao.Encerrado]
    }
];